import { ColumnType } from "components/AgGrid/constants";

import { getters } from "lib/agGrid";

import { formatRuleValueDataSource, formatRuleValueOption } from "./ruleValue";

export const MasterRuleColId = {
  APPLY_CRITERIA_FILTER_TO_SPLITS: "204d5601-4934-4ef3-88e7-0b18b7b2ebf3",
  APPLY_SPLITS: "13257e69-2ff1-4216-8735-43ad4c587535",
  COMMENT: "2fdaba6a-5994-4bb0-9463-4024d7558f92",
  CREATED: "63bc355b-6f20-413f-a1ec-926e60c89a6a",
  GL_CODE: "5b112c75-511f-4460-85a4-5802e88510b4",
  INVOICE_LINE_ITEM_TEMPLATE: "00bf9af8-ec97-4ba8-8cf3-1b719f96e405",
  LAST_MODIFIED: "489c6da5-9128-49d4-8af6-847575190a0d",
  MASTER_RULE_BOOK: "3a317be0-6dfb-4769-9fbf-d837ab7a3b53",
  MASTER_RULE_ID: "e3856d0b-c6b7-4341-9156-d8f8ee57ec04",
  NAME: "a901f1b9-1a05-4071-ab3e-a4281ac7e460",
  ORDER: "320c701b-9cfb-4dca-8670-0a81bbd3478f",
  OUTPUT_AS_SINGLE_UNIT: "b4b9a049-e44a-4077-b558-2fd203072c9d",
  PRICE_ADJUSTMENT: "c4739706-f17c-4380-9fb6-45d66749f026",
  QUANTITY_OUTPUT_FORMAT: "a01c1e6b-dbb9-49a4-b671-1fdf2b60199e",
  QUANTITY_RAW_FORMAT: "e2ec7f3f-3fb9-4c07-b5ce-cbc95af07a53",
  RULE_BOOK_ID: "d775b5d7-b379-4103-83c5-d24b086e552b",
  ROUNDING_STRATEGY: "2c9cd66f-1a0d-4997-85c2-b1963263232c",
  ROUNDING_VALUE: "91752e2f-9c55-40a9-bd01-e13ccbc9e9d0",
  SEPARATE_DOCUMENT_KEY: "d91cc53e-7a88-4836-ac3d-14d76b96228d",
  TITLE_TEMPLATE: "fd8705b2-e76b-4fab-8772-3e724e93cf1f",
  UNIT_AMOUNT_OUTPUT_FORMAT: "14d38b28-948f-4cd3-a979-497476637f2e",
  UNIT_AMOUNT_RAW_FORMAT: "27df1983-fca8-4100-8eaa-d6d280ee1338",
  UNIT_PRICE: "39b9f2ae-b382-46c1-a8b7-114bdd82a930",
  UNIT_LIMIT: "c3b3d03f-dddc-4c39-b899-a462492d46ea",
  UNIT_OFFSET: "38134a96-b702-40c9-ac4a-35a19349ec76",
  UNITS: "b10b0b15-a70b-45a0-a610-04f3d931868a",
};

export const MasterRuleColumnDefinitions = {
  [MasterRuleColId.NAME]: {
    colId: MasterRuleColId.NAME,
    field: "masterRule.name",
    headerName: "Name",
    width: 90,
    type: ColumnType.STRING,
  },
  [MasterRuleColId.GL_CODE]: {
    colId: MasterRuleColId.GL_CODE,
    field: "masterRule.gl_code",
    headerName: "GL Code",
    width: 90,
    type: ColumnType.STRING,
    valueGetter: getters.autoFieldGetter,
    filterValueGetter: getters.autoFieldGetter,
    enableRowGroup: true,
  },
  [MasterRuleColId.CREATED]: {
    colId: MasterRuleColId.CREATED,
    field: "masterRule.created",
    headerName: "Created",
    width: 90,
    type: ColumnType.UTC_LOCAL_DATE_TIME,
  },
  [MasterRuleColId.LAST_MODIFIED]: {
    colId: MasterRuleColId.LAST_MODIFIED,
    field: "masterRule.last_modified",
    headerName: "Last Modified",
    width: 90,
    type: ColumnType.UTC_LOCAL_DATE_TIME,
  },
  [MasterRuleColId.INVOICE_LINE_ITEM_TEMPLATE]: {
    colId: MasterRuleColId.INVOICE_LINE_ITEM_TEMPLATE,
    field: "masterRule.invoice_line_item_template",
    headerName: "Grouped Title",
    width: 90,
    type: ColumnType.STRING,
  },
  [MasterRuleColId.TITLE_TEMPLATE]: {
    colId: MasterRuleColId.TITLE_TEMPLATE,
    field: "masterRule.title_template",
    headerName: "Title",
    width: 90,
    type: ColumnType.STRING,
  },
  [MasterRuleColId.SEPARATE_DOCUMENT_KEY]: {
    colId: MasterRuleColId.SEPARATE_DOCUMENT_KEY,
    field: "masterRule.separate_document_key",
    headerName: "Separate Document Key",
    width: 90,
    type: ColumnType.STRING,
    enableRowGroup: true,
  },
  [MasterRuleColId.MASTER_RULE_BOOK]: {
    colId: MasterRuleColId.MASTER_RULE_BOOK,
    field: "masterRuleBook.name",
    headerName: "Master Rule Book",
    width: 90,
    type: ColumnType.STRING,
    enableRowGroup: true,
  },
  [MasterRuleColId.ORDER]: {
    colId: MasterRuleColId.ORDER,
    field: "masterRuleBook.order",
    headerName: "Order",
    width: 90,
    type: ColumnType.NUMERIC,
  },
  [MasterRuleColId.APPLY_SPLITS]: {
    colId: MasterRuleColId.APPLY_SPLITS,
    field: "masterRule.apply_splits",
    headerName: "Apply Splits",
    width: 90,
    type: ColumnType.BOOLEAN,
    enableRowGroup: true,
  },
  [MasterRuleColId.APPLY_CRITERIA_FILTER_TO_SPLITS]: {
    colId: MasterRuleColId.APPLY_CRITERIA_FILTER_TO_SPLITS,
    field: "masterRule.apply_criteria_filter_to_splits",
    headerName: "Apply Splits to Filter",
    width: 90,
    type: ColumnType.BOOLEAN,
    enableRowGroup: true,
  },
  [MasterRuleColId.UNITS]: {
    colId: MasterRuleColId.UNITS,
    field: "masterRule.parsedContent.value.units",
    headerName: "Units",
    width: 160,
    type: ColumnType.STRING,
    valueGetter: ({ data }) =>
      formatRuleValueDataSource(data?.masterRule?.parsedContent?.value?.units),
  },
  [MasterRuleColId.UNIT_PRICE]: {
    colId: MasterRuleColId.UNIT_PRICE,
    field: "masterRule.parsedContent.value.amount",
    headerName: "Unit Price",
    width: 160,
    type: ColumnType.STRING,
    valueGetter: ({ data }) =>
      formatRuleValueDataSource(data?.masterRule?.parsedContent?.value?.amount),
  },
  [MasterRuleColId.PRICE_ADJUSTMENT]: {
    colId: MasterRuleColId.PRICE_ADJUSTMENT,
    field: "masterRule.parsedContent.value.offset",
    headerName: "Price Adjustment (¢)",
    width: 160,
    type: ColumnType.STRING,
    valueGetter: ({ data }) =>
      formatRuleValueDataSource(data?.masterRule?.parsedContent?.value?.offset),
  },
  [MasterRuleColId.UNIT_OFFSET]: {
    colId: MasterRuleColId.UNIT_OFFSET,
    field: "masterRule.parsedContent.value.unit_offset",
    headerName: "Unit Offset",
    width: 160,
    type: ColumnType.STRING,
    valueGetter: ({ data }) =>
      formatRuleValueDataSource(
        data?.masterRule?.parsedContent?.value?.unit_offset,
      ),
  },
  [MasterRuleColId.UNIT_LIMIT]: {
    colId: MasterRuleColId.UNIT_LIMIT,
    field: "masterRule.parsedContent.value.unit_limit",
    headerName: "Unit Limit",
    width: 160,
    type: ColumnType.STRING,
    valueGetter: ({ data }) =>
      formatRuleValueDataSource(
        data?.masterRule?.parsedContent?.value?.unit_limit,
      ),
  },
  [MasterRuleColId.ROUNDING_STRATEGY]: {
    colId: MasterRuleColId.ROUNDING_STRATEGY,
    field: "masterRule.parsedContent.value.rounding_strategy",
    headerName: "Rounding Strategy",
    width: 160,
    type: ColumnType.STRING,
    valueGetter: ({ data }) =>
      formatRuleValueOption(
        data?.masterRule?.parsedContent?.value?.rounding_strategy,
      ),
    enableRowGroup: true,
  },
  [MasterRuleColId.ROUNDING_VALUE]: {
    colId: MasterRuleColId.ROUNDING_VALUE,
    field: "masterRule.parsedContent.value.rounding_value",
    headerName: "Rounding Value (¢)",
    width: 160,
    type: ColumnType.NUMERIC,
  },
  [MasterRuleColId.OUTPUT_AS_SINGLE_UNIT]: {
    colId: MasterRuleColId.OUTPUT_AS_SINGLE_UNIT,
    field: "masterRule.parsedContent.value.output_as_single_unit",
    headerName: "Output as 1 Unit",
    width: 160,
    type: ColumnType.BOOLEAN,
    enableRowGroup: true,
  },
  [MasterRuleColId.UNIT_AMOUNT_OUTPUT_FORMAT]: {
    colId: MasterRuleColId.UNIT_AMOUNT_OUTPUT_FORMAT,
    field: "masterRule.unit_amount_output_format",
    headerName: "Unit Amount Output Format",
    type: ColumnType.STRING,
    enableRowGroup: true,
  },
  [MasterRuleColId.UNIT_AMOUNT_RAW_FORMAT]: {
    colId: MasterRuleColId.UNIT_AMOUNT_RAW_FORMAT,
    field: "masterRule.unit_amount_raw_format",
    headerName: "Unit Amount Raw Format",
    type: ColumnType.STRING,
    enableRowGroup: true,
  },
  [MasterRuleColId.QUANTITY_OUTPUT_FORMAT]: {
    colId: MasterRuleColId.QUANTITY_OUTPUT_FORMAT,
    field: "masterRule.quantity_output_format",
    headerName: "Quantity Output Format",
    type: ColumnType.STRING,
    enableRowGroup: true,
  },
  [MasterRuleColId.QUANTITY_RAW_FORMAT]: {
    colId: MasterRuleColId.QUANTITY_RAW_FORMAT,
    field: "masterRule.quantity_raw_format",
    headerName: "Quantity Raw Format",
    type: ColumnType.STRING,
    enableRowGroup: true,
  },
};
